import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useHistory } from 'react-router';
import { useAppContext } from '../../appProvider/contextProvider';
import { Email_VALIDATOR, ERRORS, NAME_VALIDATOR } from '../../constants/AppConstants';
import parsePhoneNumber from 'libphonenumber-js';
import timezones from 'timezones-list';
import { useMutation } from 'react-query';
import { updateProfile } from '../../services/userService';
import { toast } from 'react-toastify';
import { changeCard } from '../../services/stripe';


const Profile = () => {

    const history = useHistory();

    const { userDetails, 
        setUserDetails, 
        setIsDirty,
        isDirty,
        setDiscardPromptOpen,
        cardDetails,
    } = useAppContext();

    const [ name, setName ] = useState('');
    const [ email, setEmail ] = useState('');
    const [country_code, setCountryCode] = useState('');
    const [rawPhoneNumber, setRawPhoneNumber] = useState('');
    const [phone, setPhoneNumber] = useState('');
    const [timezone, setTimezone] = useState('');

     
    const [phoneError, setPhoneError] = useState(null); 
    const [nameError, setNameError] = useState(null); 
    const [, setEmailError] = useState(null); 

    useEffect(() => {
        if(userDetails) {
            resetData();
        }
    }, [userDetails])

    const resetData = () => {
        setIsDirty(false);
        setName(userDetails.name)
        setEmail(userDetails.email);
        setCountryCode(userDetails.country_code);
        setPhoneNumber(userDetails.phone);
        setRawPhoneNumber(`${userDetails?.country_code}${userDetails?.phone}`);
        setTimezone(userDetails.timezone);
        setPhoneError(null);
        setEmailError(null);
        setPhoneError(null);
    }

    const handelPhoneNumberChange = (value, data, event, formattedValue) => {
        setIsDirty(true);
        setCountryCode(`+${data.dialCode}`)
        setPhoneNumber(value.slice(data.dialCode.length));
        setRawPhoneNumber(formattedValue);
        handelPhoneNumberValidator(formattedValue);
    }

    const handelNameValidation = (value) => {
        setIsDirty(true);
        setName(value)
        if(value.trim().length <= 0 ) {
            setNameError(ERRORS.NAME_REQUIRED);
        }
        if(value.trim().length > 30 ) {
            setNameError(ERRORS.NAME_MAX_LENGTH);
        }
        else if(!value.match(NAME_VALIDATOR)) {
            setNameError(ERRORS.IN_VALID_NAME);
        } else {
            setNameError(null);
        }
    }

    const handelEmailValidation = (value) => {
        setEmail(value);
        if(value.trim().length <= 0 ) {
            setEmailError(ERRORS.EMAIL_REQUIRED);
        }
        else if(!value.match(Email_VALIDATOR)) {
            setEmailError(ERRORS.IN_VALID_EMAIL);
        } else {
            setEmailError(null);
        }
    }

    const handelPhoneNumberValidator = (value) => {
        const phone = parsePhoneNumber(value);
        if(phone && !phone.isValid()) {
           setPhoneError(ERRORS.IN_VALID_PHONE_NUMBER); 
        } else if(!phone) {
            setPhoneError(ERRORS.PHONE_NUMBER_REQUIRED);
        } else {
            setPhoneError(null);
        }
    }


    const isSaveDisabled = () => {
        return  !isDirty || name.length <= 0 || phone.length <= 0  || nameError || phoneError;
    }

    const save = useMutation((event) => {
        event.preventDefault();
        return updateProfile({name, email, phone, country_code, timezone});
    }, {
        onSuccess: ((userData) => {
            if(userData.errors) {

            } else {
                setUserDetails(userData.user);
                toast.success('Profile updated successfully');
            }
            // toast.info(userData.detail);
        }),
        onError: ((error) => {
            // toast.error(error.message);
        })
    });

    const onBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
        } else {
            history.goBack();
        }
    }


    const getMonth = (month) => {
        if(month < 10) return `0${month}`;
        return month;
    }

    const getCardValue = () => {
        return cardDetails ?  `${cardDetails?.brand}  *****${cardDetails?.last4}   ${getMonth(cardDetails?.exp_month)}/${cardDetails?.exp_year}` : ' N/A';
    }

    const change = useMutation(() => {
        return changeCard();
    }, {
        onSuccess: ({url}) => {
            if(url) {
                window.open(url);
            }
        }
    });

    return <>
    <div className="panel full-height">
        <div className="panel-header">
            <div className="d-flex justify-content-between align-items-space-between">
                <div>
                    <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => onBack()}></i> Profile</h3>
                </div>
                <div className="d-flex justify-content-between " style={{gap: '10px'}}>
                    <button className="btn btn-sm btn-grey mr-2" onClick={() => resetData()} >Reset</button>
                    <button className="btn btn-sm btn-primary" disabled={isSaveDisabled()} onClick={save.mutate} >Save</button>                                     
                </div> 
            </div>                                 
        </div>
        <div className="panel-body d-flex flex-column full-height scrollable_y">
            <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">                   
                        <label className="form-label text-dark medium">Name</label>
                        <input 
                            type="text"
                            placeholder="Enter Your Name"
                            value={name}
                            onChange={({target}) => handelNameValidation(target.value)}
                            className="form-control"
                            />                        
                        {nameError &&  <span className="error-message">{nameError}</span>}
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">                   
                        <label className="form-label text-dark medium">Email</label>
                        <input
                            style={{background: '#e9ecef'}}
                            type="email"
                            placeholder="Enter Your Email"
                            value={email}
                            onChange={({target}) => handelEmailValidation(target.value)}
                            className="form-control"
                            disabled={true}
                            />                        
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">                   
                        <label className="form-label text-dark medium">Phone</label>
                        <PhoneInput
                            country={'us'}
                            value={rawPhoneNumber}
                            onChange={handelPhoneNumberChange}
                            placeholder="Enter Your Phone Number"
                            inputClass="form-control"
                    />                     
                    { phoneError &&  <span className="error-message">{phoneError}</span>}
                    </div>
                </div>
            </div>
            <hr/>
            <hr/>
            <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">                   
                        <label className="form-label text-dark medium">Time Zone</label>
                        <div className="custom-select">
                            <select value={timezone} onChange={({target}) => setTimezone(target.value)} className="form-control">
                                {
                                    timezones.map(({name, tzCode}, index) => <option value={tzCode} key={index} >{name}</option>)
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group">                   
                        <label className="form-label text-dark medium">Card Details 
                            <i onClick={change.mutate} className="icon icon-edit ml-2 cursor-pointer"></i> 
                        </label>
                        <input 
                            type="text" 
                            placeholder="Enter Your Email" 
                            value={getCardValue()} 
                            className="form-control"
                            disabled={true}
                            style={{textTransform: 'capitalize', background: '#e9ecef'}}
                        />                        
                    </div>
                </div>
            </div>
            <hr/>
            <div className="d-flex flex-wrap justify-content-between">
                <button className="btn btn-primary mb-2" onClick={() => history.push('/reset-password')} ><i className="icon icon-security mr-2"></i>Change Password</button>
                <button className="btn btn-danger mb-2"><i className="icon icon-delete mr-2"></i>Delete Account</button>
            </div>
        </div>
    </div>                    
</>
}


export default Profile; 